<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <path
        fill="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M17 13a1 1 0 1 0 0-2a1 1 0 0 0 0 2"
      />
      <path d="M17 17H7A5 5 0 0 1 7 7h10a5 5 0 0 1 0 10Z" />
    </g>
  </svg>
</template>
